import { render, staticRenderFns } from "./CaptureVideo.vue?vue&type=template&id=6dfd3335"
import script from "./CaptureVideo.vue?vue&type=script&lang=js"
export * from "./CaptureVideo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports